import { useState } from "react";
import { Box, Button, Text, Tabs, Checkbox } from "@chakra-ui/react";

export default function LoginPage() {
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const handleSocialLogin = (provider: string, intent: "login" | "signup") => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = `/auth/${provider}?intent=${intent}`;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    if (csrfToken) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "authenticity_token";
      input.value = csrfToken;
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <div className="min-h-[calc(100svh-64px)] flex items-start justify-center p-4 bg-gray-50">
      <div className="bg-white shadow-2xl rounded-2xl p-0 w-full max-w-md overflow-hidden border border-gray-200 translate-y-[clamp(48px,12svh,128px)]">
        <Tabs.Root defaultValue="login" variant="plain">
          <Box display="flex" justifyContent="center" px={4} mt={6}>
            <Tabs.List bg="gray.100" p={1.5} borderRadius="2xl" width="85%">
              <Tabs.Trigger
                value="login"
                flex={1}
                py={3.5}
                borderRadius="xl"
                fontWeight="semibold"
                fontSize="md"
                display="flex"
                justifyContent="center"
                alignItems="center"
                color="gray.600"
                _selected={{
                  bg: "white",
                  color: "blue.600",
                  shadow: "md",
                }}
              >
                ログイン
              </Tabs.Trigger>
              <Tabs.Trigger
                value="signup"
                flex={1}
                py={3.5}
                borderRadius="xl"
                fontWeight="semibold"
                fontSize="md"
                display="flex"
                justifyContent="center"
                alignItems="center"
                color="gray.600"
                _selected={{
                  bg: "white",
                  color: "blue.600",
                  shadow: "md",
                }}
              >
                新規登録
              </Tabs.Trigger>
            </Tabs.List>
          </Box>

          <Box p={8}>
            {/* ログインタブ */}
            <Tabs.Content value="login" className="pt-0">
              <div className="space-y-4">
                {/* 新規登録タブとの高さを揃えるためのスペーサー */}
                <Box mb={4} height="20px" />

                <div className="space-y-2">
                <Button
                  onClick={() => handleSocialLogin("google_oauth2", "login")}
                  width="full"
                  bg="gray.50"
                  color="gray.700"
                  border="1px"
                  borderColor="gray.300"
                  _hover={{ bg: "gray.100" }}
                  size="lg"
                  borderRadius="lg"
                  fontWeight="semibold"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box display="flex" alignItems="center" width="20px" height="20px" flexShrink={0}>
                    <svg className="w-5 h-5" viewBox="0 0 48 48">
                      <path
                        fill="#EA4335"
                        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                      />
                      <path
                        fill="#4285F4"
                        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                      />
                      <path
                        fill="#FBBC05"
                        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                      />
                      <path
                        fill="#34A853"
                        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                      />
                    </svg>
                  </Box>
                  <Box width="130px" textAlign="left" ml={1}>
                    Googleでログイン
                  </Box>
                </Button>

                <Button
                  onClick={() => handleSocialLogin("line", "login")}
                  width="full"
                  bg="#E8F5E9"
                  color="#059C42"
                  border="1px"
                  borderColor="#06C755"
                  _hover={{ bg: "#C8E6C9" }}
                  size="lg"
                  borderRadius="lg"
                  fontWeight="semibold"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box display="flex" alignItems="center" width="20px" height="20px" flexShrink={0}>
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
                    </svg>
                  </Box>
                  <Box width="130px" textAlign="left" ml={1}>
                    LINEでログイン
                  </Box>
                </Button>
                </div>
              </div>
            </Tabs.Content>

            {/* 新規登録タブ */}
            <Tabs.Content value="signup" className="pt-0">
              <div className="space-y-4">
                <Box mb={4} display="flex" justifyContent="center">
                  <Checkbox.Root
                    checked={agreedToTerms}
                    onCheckedChange={(e) => setAgreedToTerms(!!e.checked)}
                  >
                    <Checkbox.HiddenInput />
                    <Checkbox.Control />
                    <Checkbox.Label fontSize="sm">
                      <a
                        href="/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline hover:text-blue-800"
                      >
                        利用規約
                      </a>
                      に同意する
                    </Checkbox.Label>
                  </Checkbox.Root>
                </Box>

                <div className="space-y-2">
                  <Button
                    onClick={() => handleSocialLogin("google_oauth2", "signup")}
                    width="full"
                    bg="gray.50"
                    color="gray.700"
                    border="1px"
                    borderColor="gray.300"
                    _hover={{ bg: "gray.100" }}
                    size="lg"
                    borderRadius="lg"
                    fontWeight="semibold"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    disabled={!agreedToTerms}
                    opacity={agreedToTerms ? 1 : 0.5}
                    cursor={agreedToTerms ? "pointer" : "not-allowed"}
                  >
                    <Box display="flex" alignItems="center" width="20px" height="20px" flexShrink={0}>
                      <svg className="w-5 h-5" viewBox="0 0 48 48">
                        <path
                          fill="#EA4335"
                          d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                        />
                        <path
                          fill="#4285F4"
                          d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                        />
                        <path
                          fill="#FBBC05"
                          d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                        />
                        <path
                          fill="#34A853"
                          d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                        />
                      </svg>
                    </Box>
                    <Box width="130px" textAlign="left" ml={1}>
                      Googleで新規登録
                    </Box>
                  </Button>

                  <Button
                    onClick={() => handleSocialLogin("line", "signup")}
                    width="full"
                    bg="#E8F5E9"
                    color="#059C42"
                    border="1px"
                    borderColor="#06C755"
                    _hover={{ bg: "#C8E6C9" }}
                    size="lg"
                    borderRadius="lg"
                    fontWeight="semibold"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    disabled={!agreedToTerms}
                    opacity={agreedToTerms ? 1 : 0.5}
                    cursor={agreedToTerms ? "pointer" : "not-allowed"}
                  >
                    <Box display="flex" alignItems="center" width="20px" height="20px" flexShrink={0}>
                      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
                      </svg>
                    </Box>
                    <Box width="130px" textAlign="left" ml={1}>
                      LINEで新規登録
                    </Box>
                  </Button>
                </div>
              </div>
            </Tabs.Content>
          </Box>
        </Tabs.Root>

        <Box textAlign="center" pb={6} px={8}>
          <Text fontSize="xs" color="gray.500">
            Copyright © Open Court 2026. All rights reserved.
          </Text>
        </Box>
      </div>
    </div>
  );
}
